import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getDiscordToken(): string | null {
  return localStorage.getItem('discord_token');
}

export function setDiscordToken(token: string): void {
  localStorage.setItem('discord_token', token);
}

export function removeDiscordToken(): void {
  localStorage.removeItem('discord_token');
}
